//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/VisualReporting.js";
import "../no/NXObject.js";
let d=[[[0,"ActiveClassifier",1,"VisualReporting.Classifier",0],[0,"FilterCondition",1,"VisualReporting.Condition",0]],[[["numClassifiers"],"GetClassifiers",{R_:{classifiers:"VisualReporting.Classifier[]"}},0,0],[["classifier"],"GetIsSmartGroupDateEnabled",{R_:{isSmartGroupDateEnabled:''}},1,0],[["classifier","isSmartGroupDateEnabled"],"SetIsSmartGroupDateEnabled",{},2,0]],[]];
SPLM.VisualReporting.Rule = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.VisualReporting.Rule";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;